import { instance } from "../instance";
import { IAxiosError } from "../interfaces";
import { getError } from "../utils";
import { PATH } from "../../shared/constants";
import type { TeamPopulated } from "../../shared/interfaces";
import { applyHostnameSearchVisibility } from "../../utils/searchVisibility";

type HostnameWelcomeBody =
  | { standardDefault: true }
  | { team: TeamPopulated }
  | { notFound: true };

export type HostnameWelcomeResponse = HostnameWelcomeBody & {
  hideFromSearch?: boolean;
};

export const getWelcomeTeamForHostnameRequest = async (
  hostname: string,
): Promise<HostnameWelcomeResponse> => {
  try {
    const response = await instance.get<HostnameWelcomeResponse>(
      `${PATH.API}/${PATH.TEAM}/hostname/${encodeURIComponent(hostname)}/welcome`,
      { timeout: 25_000 },
    );
    applyHostnameSearchVisibility(response.data?.hideFromSearch === true);
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const getTeamsByHostnameRequest = async (
  hostname: string,
): Promise<TeamPopulated[]> => {
  try {
    const response = await instance.get<TeamPopulated[]>(
      `${PATH.API}/${PATH.TEAM}/hostname/${encodeURIComponent(hostname)}/teams`,
      { timeout: 25_000 },
    );
    return response.data || [];
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};
